import {
  CFA_DETAIL,
  CFA_DISTRIBUTOR_LIST,
  CFA_HEAD_QUATERS_LIST,
  CFA_LIST,
  CFA_VERSION_DETAIL,
  CFA_VERSION_LIST,
  CREATE_CFA,
  DELETE_CFA,
  EDIT_CFA,
  ENALBE_DISABLE_CFA,
  SEND_CFA_MAIL,
} from "./types";

export const cfaList = (data, onSuccess, onError) => {
  return {
    type: CFA_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const cfaCreate = (data, onSuccess, onError) => {
  return {
    type: CREATE_CFA,
    data,
    onSuccess,
    onError,
  };
};

export const cfaEdit = (data, onSuccess, onError) => {
  return {
    type: EDIT_CFA,
    data,
    onSuccess,
    onError,
  };
};

export const cfaDetail = (id, onSuccess, onError) => {
  return {
    type: CFA_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const cfaVersionList = (data, onSuccess, onError) => {
  return {
    type: CFA_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const cfaVersionDetial = (id, onSuccess, onError) => {
  return {
    type: CFA_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const cfaHeadQuaterList = (onSuccess, onError) => {
  return {
    type: CFA_HEAD_QUATERS_LIST,
    onSuccess,
    onError,
  };
};

export const cfaDistributorList = (onSuccess, onError) => {
  return {
    type: CFA_DISTRIBUTOR_LIST,
    onSuccess,
    onError,
  };
};
export const cfaEnableDisable = (id, onSuccess, onError) => {
  return {
    type: ENALBE_DISABLE_CFA,
    id,
    onSuccess,
    onError,
  };
};
export const cfaDelete = (id, onSuccess, onError) => {
  return {
    type: DELETE_CFA,
    id,
    onSuccess,
    onError,
  };
};
export const sendCfaMail = (data, onSuccess, onError) => {
  return {
    type: SEND_CFA_MAIL,
    data,
    onSuccess,
    onError,
  };
};